import { ModuleWithProviders } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

// COMPONENTS
import { AdditionReviewComponent } from "./requests/review/add/addition-review.component";
import { AddRequestComponent } from "./requests/request/add/add-request.component";
import { AdminLayoutComponent } from "./layout/admin-layout/admin-layout.component";
import { BlankLayoutComponent } from "./layout/blank-layout/blank-layout.component";
import { ContactInfoReviewComponent } from "./common/program-editors/review/contact-info/contact-info-review.component";
import { DeleteReviewComponent } from "./requests/review/delete/delete-review.component";
import { EditRequestComponent } from "./requests/request/edit/edit-request.component";
import { EditReviewComponent } from "./requests/review/edit/edit-review.component";
import { ImportToolComponent } from "./programs/import-tool/import-tool.component";
import { LoginComponent } from "./login/login.component";
import { MapComponent } from "./map/map.component";
import { MergeToolComponent } from "./programs/merge-tool/merge-tool.component";
import { ProgramComponent } from "./programs/program/program.component";
import { ProgramContactInfoEditorComponent } from "./common/program-editors/contact-info/program-contact-info-editor.component";
import { ProgramDetailsEditorComponent } from "./common/program-editors/details/program-details-editor.component";
import { ProgramDetailsReviewComponent } from "./common/program-editors/review/details/program-details-review.component";
import { ProgramListComponent } from "./programs/program-list/program-list.component";
import { ProgramRequestSubmissionComponent } from "./common/program-editors/submit/program-request-submission.component";
import { ProgramServicesEditorComponent } from "./common/program-editors/services/program-services-editor.component";
import { ProgramServicesReviewComponent } from "./common/program-editors/review/services/program-services-review.component";
import { PublicLayoutComponent } from "./layout/public-layout/public-layout.component";
import { PublicProfileComponent } from "./programs/public-profile/public-profile.component";
import { RequesterReviewComponent } from "./common/program-editors/review/requester/requester-review.component";
import { RequestListComponent } from "./requests/request-list/request-list.component";

// GUARDS
import { AuthGuard } from "./common/guards/auth.guard";
import { PublicDomainGuard } from "./common/guards/public-domain.guard";
import { AdminDomainGuard } from "./common/guards/admin-domain.guard";

const appRoutes: Routes = [
    {
        path: "", canActivate: [PublicDomainGuard], component: PublicLayoutComponent, children: [
            { path: "map", component: MapComponent },
            { path: "public-profile/:id", component: PublicProfileComponent },
            {
                path: "request-addition", component: AddRequestComponent, children: [
                    { path: "", redirectTo: "contact-info", pathMatch: "full" },
                    { path: "contact-info", component: ProgramContactInfoEditorComponent },
                    { path: "details", component: ProgramDetailsEditorComponent },
                    { path: "services", component: ProgramServicesEditorComponent },
                    { path: "submit", component: ProgramRequestSubmissionComponent }
                ]
            },
            {
                path: "request-edit/:id", component: EditRequestComponent, children: [
                    { path: "", redirectTo: "contact-info", pathMatch: "full" },
                    { path: "contact-info", component: ProgramContactInfoEditorComponent },
                    { path: "details", component: ProgramDetailsEditorComponent },
                    { path: "services", component: ProgramServicesEditorComponent },
                    { path: "submit", component: ProgramRequestSubmissionComponent }
                ]
            }
        ]
    },
    {
        path: "", canActivate: [AdminDomainGuard], component: BlankLayoutComponent, children: [
            { path: "login", component: LoginComponent }
        ]
    },
    {
        path: "", canActivate: [AdminDomainGuard], component: AdminLayoutComponent, children: [
            { path: "programs", canActivate: [AuthGuard], component: ProgramListComponent },
            {
                path: "program", canActivate: [AuthGuard], component: ProgramComponent, children: [
                    { path: "", redirectTo: "/program/contact-info", pathMatch: "full" },
                    { path: "contact-info", component: ProgramContactInfoEditorComponent },
                    { path: "details", component: ProgramDetailsEditorComponent },
                    { path: "services", component: ProgramServicesEditorComponent },
                ]
            },
            {
                path: "program/:id", canActivate: [AuthGuard], component: ProgramComponent, children: [
                    { path: "contact-info", component: ProgramContactInfoEditorComponent },
                    { path: "details", component: ProgramDetailsEditorComponent },
                    { path: "services", component: ProgramServicesEditorComponent },
                ]
            },
            { path: "requests", canActivate: [AuthGuard], component: RequestListComponent },
            {
                path: "review/add/:id", canActivate: [AuthGuard], component: AdditionReviewComponent, children: [
                    { path: "", redirectTo: "contact-info", pathMatch: "full" },
                    { path: "contact-info", component: ProgramContactInfoEditorComponent },
                    { path: "details", component: ProgramDetailsEditorComponent },
                    { path: "services", component: ProgramServicesEditorComponent },
                    { path: "requester", component: RequesterReviewComponent }
                ]
            },
            {
                path: "review/edit/:id", canActivate: [AuthGuard], component: EditReviewComponent, children: [
                    { path: "", redirectTo: "contact-info", pathMatch: "full" },
                    { path: "contact-info", component: ContactInfoReviewComponent },
                    { path: "details", component: ProgramDetailsReviewComponent },
                    { path: "services", component: ProgramServicesReviewComponent },
                    { path: "requester", component: RequesterReviewComponent }
                ]
            },
            { path: "review/delete/:id", canActivate: [AuthGuard], component: DeleteReviewComponent }
        ]
    }
];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// C:/WORK/Projects/ActNow_NG2/src/app/app.routing.ts